import { render, staticRenderFns } from "./BottomRightTable3.vue?vue&type=template&id=3d313292"
import script from "./BottomRightTable3.vue?vue&type=script&lang=js"
export * from "./BottomRightTable3.vue?vue&type=script&lang=js"
import style0 from "./BottomRightTable3.vue?vue&type=style&index=0&id=3d313292&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports